import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { Container } from './container';

const Wrapper = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;

  > .container {
    max-width: 210px;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.7);

    > .title {
      font-size: 12px;
    }

    > .subtitle {
      font-size: 12px;
    }

    .x-viewport-md & {
      max-width: 450px;
      padding: 20px;

      > .title {
        font-size: 16px;
      }
      > .subtitle {
        font-size: 12px;
      }
    }
  }
`;

export const Complete = ({ className }: { className?: string }): React.ReactElement => (
  <Wrapper className={cx('text-center', className)}>
    <Container className='container'>
      <p className='title my-0px font-weight-bold'>Stream Ended</p>
      <p className='subtitle my-0px mt-8px font-weight-bold'>
        This event has ended! Please stay tuned for future broadcasts
      </p>
    </Container>
  </Wrapper>
);
